/**
 * Add functions for Google Analytics Universal
 * */

(function (wpm, $, undefined) {

	wpm.getGAUAOrderItems = function () {

		// "id"           : "34",
		// "name"         : "Hoodie",
		// "brand"        : "",
		// "category"     : "Hoodies",
		// "list_position": 1,
		// "price"        : 45,
		// "quantity"     : 1,
		// "variant"      : "Color: blue | Logo: yes"


		let orderItems    = [],
			list_position = 1

		for (const [key, item] of Object.entries(wpmDataLayer.order.items)) {

			let orderItem

			orderItem = {
				quantity     : item.quantity,
				price        : item.price,
				name         : item.name,
				currency     : wpmDataLayer.order.currency,
				category     : wpmDataLayer.products[item.id].category.join("/"),
				list_position: list_position,
			}

			if (wpmDataLayer?.general?.variationsOutput && 0 !== item.variation_id) {

				orderItem.id      = String(wpmDataLayer.products[item.variation_id].dyn_r_ids[wpmDataLayer.pixels.google.analytics.id_type])
				orderItem.variant = wpmDataLayer.products[item.variation_id].variant_name
				orderItem.brand   = wpmDataLayer.products[item.variation_id].brand
			} else {

				orderItem.id    = String(wpmDataLayer.products[item.id].dyn_r_ids[wpmDataLayer.pixels.google.analytics.id_type])
				orderItem.brand = wpmDataLayer.products[item.id].brand
			}

			orderItems.push(orderItem)
			list_position++
		}

		return orderItems
	}

}(window.wpm = window.wpm || {}, jQuery))
